import store from '@/store';
import { Route } from 'vue-router';
import { NavigationGuardNext } from 'vue-router/types/router';
import { RouteName } from '@/router/types';

export function settingsMobileGuard(to: Route, from: Route, next: NavigationGuardNext): boolean {
  if (!store.getters['tenant/isMobileEnabled']) {
    next({ name: RouteName.Settings });
  } else {
    next();
  }
  return true;
}
